<template>
  <div class="h-full w-full overflow-hidden rounded-lg">
    <table class="w-full overflow-y-auto overflow-x-hidden">
      <thead>
        <tr>
          <th>Best</th>
          <th>Operação</th>
          <th width="33%">Resultado</th>
        </tr>
      </thead>
      <transition-group
        tag="tbody"
        name="fade"
        mode="out-in"
        class="bg-ontick-graphite-500"
      >
        <tr v-if="!getUserBests.length" key="mobile_no_data">
          <td colspan="3">
            <span> Nenhuma best em andamento </span>
          </td>
        </tr>
        <tr
          v-for="item in getUserBests"
          :key="item.bo_id"
          role="button"
          @click="openStopDrawer(item)"
          class="relative"
        >
          <td class="relative">
            <div class="flex h-full flex-col gap-2">
              <img
                :src="`/img/${item.bo_symbol.toLowerCase()}.jpg`"
                class="absolute top-1/2 left-0 h-full w-full -translate-y-1/2 transform object-cover opacity-50"
              />
              <div
                class="to-ontick-graphite-500 absolute inset-0 bg-gradient-to-r from-transparent"
              ></div>
              <div class="relative z-10 flex flex-col gap-1">
                <span class="text-sm font-bold leading-none text-gray-50">
                  {{ item.label }}
                </span>
                <span class="font-semibold text-gray-300 drop-shadow-md">
                  {{ item.bo_target }}
                </span>
              </div>
            </div>
          </td>
          <td class="align-top">
            <div class="flex flex-col">
              <div
                class="flex max-w-min items-center rounded-full pr-2 text-gray-50"
                :class="
                  item.bo_direction == 'BUY'
                    ? 'bg-ontick-green-600'
                    : 'bg-ontick-orange-600'
                "
              >
                <i
                  v-if="item.bo_direction == 'BUY'"
                  v-html="$icons.trend_up"
                ></i>
                <i
                  v-else-if="item.bo_direction == 'SELL'"
                  v-html="$icons.trend_down"
                ></i>
                <span class="direction-shadow text-[10px] uppercase">
                  {{ item.bo_direction == "BUY" ? "Sobe" : "Desce" }}
                </span>
              </div>
              <span class="font-semibold"> {{ item.bo_multiplier }}x </span>
            </div>
          </td>
          <td class="align-top">
            <div class="flex flex-col items-start justify-start gap-2">
              <div class="flex items-center gap-2 whitespace-nowrap">
                <div class="h-3 w-3">
                  <i v-if="pnl(item).result > 0" v-html="$icons.play_green"></i>
                  <i
                    v-else-if="pnl(item).result < 0"
                    v-html="$icons.play_red"
                  ></i>
                  <div v-else class="h-3 w-3 rounded-full bg-gray-500"></div>
                </div>
                <span class="max-w-[75px] overflow-visible font-semibold">
                  <template v-if="pnl(item).result">
                    {{ pnl(item).result | currency }}
                  </template>
                  <template v-else>
                    {{ 0 | currency }}
                  </template>
                </span>
              </div>
              <!-- <span>
                {{ pnl(item).difference
                }}{{ targetType(item.best_target_type) }}
              </span> -->
              <best-progress-bar-component
                :symbol="item.bo_symbol"
                :entry_price="item.bo_entry_price"
                :target="item.bo_target"
                :target_type="item.best_target_type"
                :direction="item.bo_direction"
              />
            </div>
          </td>
          <best-mask-component
            v-if="item.mask"
            :pnl="item.mask.pnl"
            :bo_id="item.bo_id"
          />
        </tr>
      </transition-group>
    </table>
    <portal to="modal">
      <best-stop-drawer-component
        :data="stop_data"
        :active="stop_drawer_is_active"
        @close="stop_drawer_is_active = false"
      />
    </portal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import event_bus from "../../../shared/utils/event_bus";
import symbol_images from "../symbol_images";
import bestStopDrawerComponent from "./best-stop-drawer.component.vue";
import pnlMixin from "../pnl";
import BestMaskComponent from "./best-mask.component.vue";
import BestProgressBarComponent from "./best-progress-bar.component.vue";
export default {
  mixins: [pnlMixin, symbol_images],

  components: {
    bestStopDrawerComponent,
    BestMaskComponent,
    BestProgressBarComponent,
  },

  data() {
    return {
      stop_drawer_is_active: false,
      stop_data: {},
    };
  },

  computed: {
    ...mapGetters({
      getUserBests: "bests/getUserBests",
      getSymbolData: "bests/getSymbolData",
      getSymbolPrice: "marketdata/getSymbolPrice",
    }),
  },

  methods: {
    openStopDrawer(order) {
      this.stop_data = order;
      this.stop_drawer_is_active = true;
    },
    targetType(best_target_type) {
      switch (best_target_type) {
        case "POINTS":
          return "p";
        case "PERCENT":
          return "%";
        default:
          return "";
      }
    },
  },

  mounted() {
    event_bus.$on("BEST_STOPPED", () => {
      this.stop_drawer_is_active = false;
    });
  },
};
</script>

<style lang="scss" scoped>
th {
  @apply bg-ontick-steel-600 px-3 py-2 text-left text-sm;
}

td {
  @apply bg-ontick-graphite-600 overflow-hidden px-3 py-2 text-left text-xs;
}
</style>
